import React from 'react';
import { IndustryCaseStudy } from '../../data/industryData';
import '../../styles/CaseStudies.css';

interface CaseStudiesProps {
  caseStudies: IndustryCaseStudy[];
}

const CaseStudies: React.FC<CaseStudiesProps> = ({ caseStudies }) => {
  return (
    <div className="case-studies-section">
      <div className="case-studies-container">
        <h2 className="case-studies-title">Customer Success Stories</h2>
        <p className="case-studies-subtitle">
          See how we've helped organizations overcome complex challenges and achieve measurable results
        </p>
        
        <div className="case-studies-grid">
          {caseStudies.map((caseStudy, index) => (
            <div className="case-study-card" key={index}>
              <h3 className="case-study-title">{caseStudy.title}</h3>
              
              <div className="case-study-content">
                <div className="case-study-row">
                  <h4>Challenge:</h4>
                  <p>{caseStudy.challenge}</p>
                </div>
                
                <div className="case-study-row">
                  <h4>Solution:</h4>
                  <p>{caseStudy.solution}</p>
                </div>
                
                <div className="case-study-row">
                  <h4>Impact:</h4>
                  <p>{caseStudy.impact}</p>
                </div>
                
                {caseStudy.metrics && (
                  <div className="case-study-metrics">
                    {caseStudy.metrics.map((metric, idx) => (
                      <div className="case-study-metric" key={idx}>
                        <div className="metric-value">{metric.value}</div>
                        <div className="metric-label">{metric.label}</div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CaseStudies; 